import React from "react";

/* =========================================================
   TargetProgressCard
   Reusable progress bar + stats card for a single target.
   Used by employee/MyTarget.jsx (current target) and can be
   reused anywhere a single target needs a visual summary.
========================================================= */
function TargetProgressCard({ target }) {
  if (!target) return null;

  const {
    title,
    target_type,
    total_target,
    completed_target,
    remaining_target,
    progress_percent,
    status,
    end_date,
  } = target;

  const daysLeft = end_date
    ? Math.ceil((new Date(end_date) - new Date()) / (1000 * 60 * 60 * 24))
    : null;

  const barColor =
    status === "Completed" ? "#16a34a" : status === "Expired" ? "#ef4444" : "#4f46e5";

  return (
    <div className="target-progress-card">
      <div className="tpc-header">
        <div>
          <h3>{title}</h3>
          <span className="tpc-type">{target_type}</span>
        </div>
        <span className={`tpc-status status-${(status || "").toLowerCase()}`}>{status}</span>
      </div>

      <div className="tpc-bar-track">
        <div
          className="tpc-bar-fill"
          style={{ width: `${Math.min(progress_percent || 0, 100)}%`, background: barColor }}
        />
      </div>

      <div className="tpc-stats">
        <div>
          <span className="tpc-stat-value">{completed_target ?? 0}</span>
          <span className="tpc-stat-label">Completed</span>
        </div>
        <div>
          <span className="tpc-stat-value">{remaining_target ?? total_target}</span>
          <span className="tpc-stat-label">Remaining</span>
        </div>
        <div>
          <span className="tpc-stat-value">{total_target}</span>
          <span className="tpc-stat-label">Total</span>
        </div>
        <div>
          <span className="tpc-stat-value">{progress_percent ?? 0}%</span>
          <span className="tpc-stat-label">Progress</span>
        </div>
      </div>

      {daysLeft !== null && (
        <div className="tpc-footer">
          {daysLeft >= 0
            ? `${daysLeft} day${daysLeft === 1 ? "" : "s"} left · ends ${new Date(
                end_date
              ).toLocaleDateString("en-IN")}`
            : `Ended ${new Date(end_date).toLocaleDateString("en-IN")}`}
        </div>
      )}
    </div>
  );
}

export default TargetProgressCard;
